import { render, staticRenderFns } from "./InstanceCardImgInstallationPending.vue?vue&type=template&id=2ae38f24&scoped=true"
import script from "./InstanceCardImgInstallationPending.vue?vue&type=script&lang=js"
export * from "./InstanceCardImgInstallationPending.vue?vue&type=script&lang=js"
import style0 from "./InstanceCardImgInstallationPending.vue?vue&type=style&index=0&id=2ae38f24&prod&lang=scss&scoped=true"
import style1 from "./InstanceCardImgInstallationPending.vue?vue&type=style&index=1&id=2ae38f24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae38f24",
  null
  
)

export default component.exports